import {stockSummary, StockSummary} from "./stock-summary/StrategyBuilderStockSummaryComponent";
import {stockDetail, StockDetail} from "./stock-detail/StrategyBuilderStockDetailComponent";
import {stockChart, StockChart} from "./stock-chart/StockChartComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.strategy-builder.components", [])
                  .component(StockSummary, stockSummary(rootDir))
                  .component(StockDetail, stockDetail(rootDir))
                  .component(StockChart, stockChart(rootDir))
                  .name;
}
